<template>
  <div class="home">
    <Header />
    <main>
      <Carousel />
      <NewsSection />
      <ServiceSection />
      <AboutSection />
      <BranchSection />
      <MemberSection />
      <ContactSection />
    </main>
    <FloatingWindow />
    <AppFooter />
  </div>
</template>

<script>
import Header from '../components/Header.vue'
import Carousel from '../components/Carousel.vue'
import NewsSection from '../components/NewsSection.vue'
import ServiceSection from '../components/ServiceSection.vue'
import AboutSection from '../components/AboutSection.vue'
import BranchSection from '../components/BranchSection.vue'
import MemberSection from '../components/MemberSection.vue'
import ContactSection from '../components/ContactSection.vue'
import FloatingWindow from '../components/FloatingWindow.vue'
import AppFooter from '../components/Footer.vue'

export default {
  name: 'HomePage',
  components: {
    Header,
    Carousel,
    NewsSection,
    ServiceSection,
    AboutSection,
    BranchSection,
    MemberSection,
    ContactSection,
    FloatingWindow,
    AppFooter
  }
}
</script>

<style scoped>
.home {
  font-family: var(--font-family);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: var(--text-primary);
  margin: 0;
  background-color: var(--bg);
  min-height: 100vh;
}

main {
  position: relative;
  z-index: 1;
}
</style>
